export default {
  name: 'seckill',
  label: {
    title: '秒杀模块',
    icon: require('@/assets/icon-component-label_Seckill.svg'),
    limit: 1
  },
  sort: 1000,
}
